import { Button, Form, Input } from "antd";
import BackTitle from "../common/BackTitle";
import FormPage from "../common/FormPage";
import { useEffect } from "react";
import axiosInstance from "../common/api";
import { useNavigate, useParams } from "react-router-dom";
import IBAN from 'iban'
import { requiredField } from "../common/common";

export default function () {
    const [form] = Form.useForm();
    const { id } = useParams();
    const navigate = useNavigate()

    useEffect(() => {
        axiosInstance
            .get(`/employee/${id}/bankAccount`)
            .then(({ data }) => form.setFieldsValue(data));
    });
    const onFinish = (data) => {
        axiosInstance.put(`/employee/${id}/bankAccount`,data)
        .then(() => {
                navigate(-1)
            })
    }

    return (
        <>
            <FormPage title="Modifica dati bancari" form={form} onFinish={onFinish}>
                <Form.Item label="Intestatario" name="name" rules={[requiredField]} hasFeedback>
                    <Input autoComplete="off"/>
                </Form.Item>
                <Form.Item
                    label="IBAN"
                    name="iban"
                    hasFeedback
                    rules={[
                        requiredField, 
                        {
                            required: true,
                            validator: (_, value) => {
                                if (!value || IBAN.isValid(value)) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(
                                    new Error("IBAN non valido"),
                                );
                            },
                        },
                    ]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item style={{ textAlign: "end" }}>
                    <Button htmlType="submit" type="primary">
                        Salva
                    </Button>
                </Form.Item>
            </FormPage>
        </>
    );
}
